export const fiscalData = {
	title: "DONNÉES FISCALES",
	fields: {
		ncm: {
			label: "NCM",
			placeholder: "Saisir NCM",
			tooltip: "Nomenclature Commune du Mercosur",
		},
		cest: {
			label: "CEST",
			placeholder: "Saisir CEST",
			tooltip: "Code Spécificateur de Substitution Fiscale",
		},
		fiscalProfile: {
			label: "Profil fiscal",
			placeholder: "Sélectionner le profil fiscal",
			loading: "Chargement...",
			tooltip:
				"Ensemble de données qui décrit la situation fiscale d'une personne ou d'une entreprise.",
		},
		fiscalGroup: {
			label: "Groupe fiscal",
			placeholder: "Sélectionner le groupe fiscal",
			loading: "Chargement...",
			tooltip:
				"Le groupe fiscal est un code qui classe les produits selon leur imposition.",
		},
	},
};
